import {
  DonePayloadType,
  FinishedPayloadType,
  MetadataPayloadType,
  ScriptLogPayloadType,
  PromptPayloadType,
  RequestOauthPayloadType,
  UserNetworkPayloadType,
  CdpTargetPayloadType,
} from "../types/promptTypes";
import { usePromptStore } from "../store/promptStore";
import { useAuthStore } from "../store/authStore";
import { Screen } from "../types/enums";
import pluto from "../plutoSdk";
import useOauthStore from "../store/ouathStore";
import { useProofStore } from "../store/proofStore";
import { ErrorPayload, ProofPayload } from "../types";
import { getProof } from "@plutoxyz/frame-js";
import { useDemoStore } from "../store/demoStore";

export const handleRequestPrompt = (
  data: PromptPayloadType,
  sessionId: string = useAuthStore.getState().sessionId
) => {
  const { setPrompts, setMetadata } = usePromptStore.getState();

  sessionStorage.setItem(
    `${sessionId}-screen`,
    JSON.stringify({ prompts: data, oauth: null })
  );
  const { prompts, ...metadata } = data;
  setPrompts(prompts);
  setMetadata(metadata);

  useAuthStore.setState({ screen: Screen.CREDENTIALS });
};

export const handleScriptLog = (data: ScriptLogPayloadType) => {
  const { logs } = data;
  pluto.scriptLog(logs);
};

export const handleRequestOauth = (data: RequestOauthPayloadType) => {
  sessionStorage.setItem(
    `${useAuthStore.getState().sessionId}-screen`,
    JSON.stringify({ oauth: data, prompts: null })
  );
  useOauthStore.setState({ oauth: data });
  useAuthStore.setState({ screen: Screen.OAUTH });
};

export const handleDone = async (data: DonePayloadType) => {};

export const handleClose = () => {
  useAuthStore.getState().deepClearSession();
};

export const handleError = (data: ErrorPayload) => {
  usePromptStore.getState().setError(data);
  useAuthStore.getState().setScreen(Screen.ERROR);
};

export const handleMetadata = (data: MetadataPayloadType) => {
  console.debug("metadata", data);
};

export const handleFinished = async (data: FinishedPayloadType) => {
  const response = await getProof(
    useAuthStore.getState().sessionId,
    useDemoStore.getState().endpoints.notary
  );

  useProofStore.getState().setProof(response as ProofPayload);
  useAuthStore.getState().setScreen(Screen.PROOF_COMPLETION);
  sessionStorage.removeItem(`${useAuthStore.getState().sessionId}-screen`);
  sessionStorage.removeItem("pluto-session-id");
  pluto.success(response as ProofPayload);
};

export const handleTimeout = () => {
  useAuthStore.getState().deepClearSession();
  pluto.timeout();
};

export const handleUserNetwork = (data: UserNetworkPayloadType) => {
  usePromptStore.getState().setProxyUrl(data.proxy_url);
  useAuthStore.getState().setScreen(Screen.USER_NETWORK);
};

export const handleUserNetworkDone = () => {
  usePromptStore.getState().setProxyUrl("");
  useAuthStore.getState().setScreen(Screen.PENDING);
};

export const handleCdpTarget = (data: CdpTargetPayloadType) => {
  pluto.notifyCdpUrl(data.websocket_debugger_page_url);
};
